module.exports = __webpack_public_path__ + "img/AL802-2-EN.b689e704.jpg";